export const createSlackRecipientItem = (slackEl: SlackRecipient) => ({
  type: 'Slack' as SlackRecipientType,
  value: slackEl.id,
  _label: slackEl
    ? `${(slackEl as SlackRecipient)?.label} [${(slackEl as SlackRecipient)?.type}]`
    : 'Private Channel',
});

export const createDealRoomRecipientItem = () => ({
  type: 'Sweep_Created_Slack_Channel' as SlackRecipientType,
  _label: "Record's deal room",
});
